import { z } from 'zod';

export const lotSizingAddLineSchema = z.object({
  lotSizingId: z.string(),
  productId: z
    .union([
      z.string().min(1, 'This value should be of type int.'),
      z.number().int({ message: 'This value should be of type int.' }),
    ])
    .transform((val) => (typeof val === 'string' ? Number(val) : val))
    .pipe(
      z
        .number({ error: 'This value should be of type int.' })
        .int({ message: 'This value should be of type int.' }),
    ),
});

export type CreateLotSizingLineInput = z.input<typeof lotSizingAddLineSchema>;

export type CreateLotSizingLine = z.infer<typeof lotSizingAddLineSchema>;
